import React, { ChangeEvent, InputHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { tr } from 'i18n'
import { normalizeVehicleNumber } from 'service/VehicleNumberService'
import './VehicleNumberInput.scss'

export default function VehicleNumberInput({ value, onChange, className = '', placeholder, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  useTranslation()
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.target.value = normalizeVehicleNumber(event.target.value)
    onChange?.(event)
  }
  return <input {...props} value={normalizeVehicleNumber(value)} onChange={handleChange}
    placeholder={placeholder || tr('Например, 01KG001BF')} className={`vehicle-number-input ${className}`} />
}
